import React from 'react';

export const Footer = () => {
  return (
    <footer className="text-center py-3  mt-4" style = {{position: 'relative', bottom: '0', width: '100%', backgroundColor: '#343a40',color:"white"}}>
      <small>
        © {new Date().getFullYear()} Irfan Khan | All Rights Reserved
      </small>
    </footer>
  );
};

